<template>
  <div class="cooperation-search-head-cp-container">
    <header>
      <div class="head-container" v-if="showBg">
        <img style="width:100%" :src="bgUrl" alt="" v-if="bgUrl" />
        <img
          style="width:100%"
          v-else
          src="../../../common/images/visa-change/visa-head-bg.png"
          alt=""
        />
      </div>
      <van-sticky>
        <div class="head-search" :class="{ shadow: shadow }">
          <div class="search-input">
            <van-field
              v-model="value"
              maxlength="50"
              :placeholder="placeholder"
              @input="handSearch"
            >
              <!-- <van-icon slot="left-icon" name="search"></van-icon> -->
              <span slot="left-icon"
                ><img
                  class="search-icon"
                  src="../../../common/images/visa-change/black-search.png"
                  alt=""
              /></span>
              <van-icon
                slot="right-icon"
                v-if="value"
                name="close"
                @click="onCancel"
              ></van-icon>
            </van-field>
            <slot></slot>
          </div>
          <div @click.stop="handSearchClick" style="color: #4AB16D">搜索</div>
        </div>
        <van-dropdown-menu
          :close-on-click-outside="false"
          active-color="#333"
          v-if="showMenu"
        >
          <van-dropdown-item
            v-model="buguid"
            value="buguid"
            :options="options"
            @change="handChange"
          />
          <van-dropdown-item :title="titleInfo.selectTitle" ref="item">
            <div class="select-date">
              <div class="content">
                <div class="title">{{ titleInfo.selectname }}：</div>
                <div class="date-wrap">
                  <span @click="handSelectDate(0)">{{
                    startTime ? startTime : '请选择时间'
                  }}</span
                  >至<span @click="handSelectDate(1)">{{
                    endTime ? endTime : '请选择时间'
                  }}</span>
                </div>
              </div>
              <div class="footbar">
                <div class="footbar-wrap">
                  <span @click="handCancelMenu">重置</span
                  ><span @click="handSubmit">确认</span>
                </div>
              </div>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-sticky>
    </header>
    <van-popup v-model="popupShowStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        @cancel="handCancel(0)"
        @confirm="e => handConfirm(0, e)"
        type="date"
        :min-date="minDateStart"
        :max-date="maxDateStart"
        :formatter="formatter"
      />
    </van-popup>
    <van-popup v-model="popupShowEnd" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        @cancel="handCancel(1)"
        @confirm="e => handConfirm(1, e)"
        type="date"
        :min-date="minDateEnd"
        :max-date="maxDateEnd"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Field,
  Icon,
  Notify,
  Popup,
  DatetimePicker,
  Search,
  Toast,
  Sticky,
  DropdownMenu,
  DropdownItem
} from 'vant';
import moment from 'moment';

export default {
  name: 'cooperation-search-head-cp',

  data() {
    return {
      value: '',
      searchParams: {
        searchData: '',
        buguid: '',
        startDate: '',
        endDate: ''
      },
      buguid: '',
      startDate: new Date(),
      endDate: new Date(),
      popupShowStart: false,
      popupShowEnd: false,
      minDateStart: new Date(1900, 0, 1),
      maxDateStart: new Date(2050, 0, 1),
      minDateEnd: new Date(1900, 0, 1),
      maxDateEnd: new Date(2050, 0, 1),
      startTime: '',
      endTime: '',
      timeActive: '',
      switch1: false,
      switch2: false,
      options: [{ text: '所属公司', value: '' }]
    };
  },
  mounted() {},
  props: {
    showBg: {
      type: Boolean,
      default: true
    },
    companyList: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请输入关键字搜索'
    },
    titleInfo: {
      type: Object,
      dafault: {
        selectname: '申报日期',
        selectTitle: '申报日期范围'
      }
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: false
    },
    bgUrl: {
      type: String,
      default: ''
    }
  },
  created() {},
  components: {
    [Field.name]: Field,
    [Search.name]: Search,
    [Notify.name]: Notify,
    'van-icon': Icon,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Sticky.name]: Sticky,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },

  methods: {
    handSelectDate(type) {
      type ? (this.popupShowEnd = true) : (this.popupShowStart = true);
    },
    handCancel(type) {
      type ? (this.popupShowEnd = false) : (this.popupShowStart = false);
    },
    handConfirm(type, e) {
      type
        ? (this.endTime = moment(e).format('YYYY-MM-DD'))
        : (this.startTime = moment(e).format('YYYY-MM-DD'));
      type ? (this.popupShowEnd = false) : (this.popupShowStart = false);
    },
    handSubmit() {
      let { startTime, endTime } = this;
      this.searchParams = {
        ...this.searchParams,
        startDate: startTime,
        endDate: endTime
      };
      this.$emit('handSearch', this.searchParams);
      this.$refs.item.toggle();
    },
    format(startDate, endDate) {
      startDate = moment(startDate).format('YYYY-MM-DD');
      endDate = moment(endDate).format('YYYY-MM-DD');
      return {
        startDate,
        endDate
      };
    },
    handChange(value) {
      this.searchParams = { ...this.searchParams, buguid: value };
      this.$emit('handSearch', this.searchParams);
    },
    handCancelMenu() {
      this.searchParams = { ...this.searchParams, startDate: '', endDate: '' };
      this.startTime = '';
      this.endTime = '';
      this.$emit('handSearch', this.searchParams);

      this.$refs.item.toggle();
    },
    handSearch(v) {
      if (v && v.trim().length == 0) {
        Toast.fail('搜索条件不能为空格');
        return;
      }
      if (v && v.trim().length == 200) {
        Toast.fail('最大字符为200');
        return;
      }
      let reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      v = v && v.replace(reg, '');
      this.value = v;

      this.searchParams = { ...this.searchParams, searchData: v };
    },
    handSearchClick() {
      this.$emit('handSearch', this.searchParams);
    },
    onCancel() {
      this.value = '';
      this.searchParams = { ...this.searchParams, searchData: '' };
      this.$emit('handSearch', this.searchParams);
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    formatDate(dates) {
      let date = new Date(dates);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + '/' + this.formatTen(month) + '/' + this.formatTen(day);
    },
    formatTen(num) {
      return num > 9 ? num + '' : '0' + num;
    }
  },
  watch: {
    companyList: {
      handler: function() {
        this.options[0]['text'] = this.titleInfo.subtitle
          ? this.titleInfo.subtitle
          : '所属公司';
        this.options = this.options.concat(this.companyList);
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-search-head-cp-container {
  header {
    // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  }
  .head-container {
    height: 160px;
    // background: url("../../../common/images/visa-change/visa-head-bg.png")
    // no-repeat center;
    // background-size: 100% 100%;
  }
  .search-icon {
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: unset;
    position: relative;
    top: -2px;
  }
  .head-search {
    height: 88px;
    background: white;
    display: flex;
    align-items: center;
    .van-search__content {
      display: flex;
      flex: 1;
      padding-left: 0.16rem;
      border-radius: 2px;
      background: #fff;
    }
    .van-search {
      padding: 0px;
    }
    .icon-date {
      position: relative;
      vertical-align: middle;
      top: 2px;
      margin-left: 30px;
      img {
        width: 44px;
        height: 44px;
        display: inline-block;
      }
      span {
        position: absolute;
        left: 0px;
        top: 8px;
        color: #333;
        vertical-align: middle;
        text-align: center;
        line-height: 30px;
      }
    }
    /deep/ .van-field__left-icon {
      margin-right: 0.1rem;
      padding-left: 20px;
      padding-top: 10px;
    }
    /deep/ .van-field__right-icon {
      padding-right: 40px;
    }
    .search-input {
      width: 100%;
      padding-left: 32px;
      // padding-top: 18px;
      padding-right: 32px;
      display: flex;
      justify-items: center;
      > div:nth-child(1) {
        width: 100%;
      }
      .van-cell {
        height: 54px;
        padding: 0px;
        line-height: 2;
      }
    }
    > div:nth-child(2) {
      width: 120px;
      // border: 1px solid red;
      color: #666;
    }
  }
  .shadow {
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  }
  /deep/.van-dropdown-menu {
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
    .van-dropdown-menu__item {
      position: relative;
    }
    .van-dropdown-menu__item:nth-child(1) {
      .van-ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 270px;
      }
    }
    .van-dropdown-menu__item::after {
      position: absolute;
      content: '';
      right: 0px;
      border: 1px solid #efefef;
      height: 100%;
      transform: scaleX(0.5);
    }
    //  .van-dropdown-menu__item:last-child::after{
    //    border: none
    //  }
  }
  .select-date {
    .content {
      height: 196px;
      padding: 40px 0px 0px 30px;
      .title {
        color: #333333;
        font-size: 28px;
      }
      .date-wrap {
        display: flex;
        align-items: center;
        margin-top: 20px;
        span {
          width: 320px;
          height: 68px;
          border: 1px solid rgba(185, 185, 185, 1);
          border-radius: 8px;
          display: inline-block;
          color: #999;
          font-size: 28px;
          text-align: center;
          line-height: 68px;
        }
        span:nth-child(1) {
          margin-right: 10px;
        }
        span:nth-child(2) {
          margin-left: 10px;
        }
      }
    }
    .footbar {
      height: 88px;
      position: relative;
      .footbar-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #656565;
        font-size: 32px;
        span {
          flex: 1;
          text-align: center;
          display: inline-block;
          height: 100%;
          line-height: 88px;
          position: relative;
        }
        span:nth-child(1)::after {
          position: absolute;
          content: '';
          border-right: 1px solid #d5d9df;
          transform: scaleX(0.5);
          right: 0px;
          top: 0px;
          height: 100%;
          display: inline-block;
        }
        span:nth-child(2) {
          color: #41c795;
        }
      }
    }
    .footbar::before {
      position: absolute;
      content: '';
      border-top: #d5d9df 1px solid;
      display: block;
      transform: scaleY(0.5);
      width: 100%;
    }
  }
  .head-select {
    height: 88px;
    display: flex;
    background: white;
    border-top: 1px solid #f2f2f2;
    justify-content: space-around;
    .select-item {
      width: 33.33%;
      position: relative;
      .slot-date {
        border-top: 1px solid #efefef;
        font-size: 28px;
        overflow: hidden;
        .toolbar {
          height: 88px;
          display: flex;
          width: 100%;
          line-height: 88px;
          border-top: 1px solid #efefef;
          .toolbar-item {
            width: 50%;
            text-align: center;
            display: inline-block;
            color: #666666;
          }
          .toolbar-item:nth-child(2) {
            border-left: 1px solid #efefef;
            color: #42c796;
          }
        }
        .date-title {
          color: #333333;
          margin-top: 30px;
          margin-left: 20px;
        }
        .empty-time {
          color: rgba(153, 153, 153, 1);
        }
        .time-active {
          border: 1px solid rgba(66, 199, 150, 1) !important;
        }
        span {
          margin-top: 30px;
          margin-bottom: 30px;
          float: left;
        }
        .date-center {
          display: inline-block;
          padding: 0 20px 0 20px;
          height: 68px;
          line-height: 68px;
        }
        .date-box {
          display: inline-block;
          height: 68px;
          padding-left: 15px;
          line-height: 68px;
          width: 320px;
          border-radius: 8px;
          border: 1px solid rgba(186, 186, 186, 1);
        }
        .date-box:nth-child(2) {
          margin-left: 20px;
        }
      }
    }
    // .select-item ::after{
    //   position: absolute;
    //   content: '';
    //   border: 1px solid #EFEFEF;
    //   height: 40px;
    //   transform: scaleX(.5);
    //   right: -10px;
    // }
    // .select-item:last-child{
    //   border: none
    // }
  }
}
.cooperation-search-head-cp-container {
  .search-input {
    .van-cell {
      background: #efefef;
      height: 54px;
      border-radius: 27px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .van-icon {
      line-height: normal;
      color: #8f8f8f;
    }
  }
  .van-picker__cancel,
  .van-picker__confirm {
    color: #4ab16d !important;
  }
  .van-picker-column__item--selected {
    color: #4ab16d !important;
  }
  /veep/ .van-field__right-icon {
    padding-right: 20px;
  }
}
/deep/.van-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
/deep/ .van-picker__cancel,
.van-picker__confirm {
  height: 100%;
  padding: 0 0.32rem;
  font-size: 0.28rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #42c796;
}
/deep/ .van-picker__confirm {
  color: #42c796;
}
/deep/ .van-picker-column__item--selected {
  color: #42c796;
}
</style>
